import axios from 'axios';

const client = axios.create({
    method: "POST",
    withCredentials: true,
    headers: {
        //DeviceType: 'ios'
    },
});

const request = function (options) {
    const userLanguage = localStorage.getItem('language');
    const env = window.location.pathname.replace(/^\/([^\/]*)\/([^\/]*).*$/, '$1');
    const app = window.location.pathname.replace(/^\/([^\/]*)\/([^\/]*).*$/, '$2');
    const api = options.api ? options.api : 'api'
    let API;
    if (process.env.NODE_ENV === 'development') {
        API = `https://dev.local/${env}/${api}/${app}/`
    } else if (process.env.NODE_ENV === 'production') {
        API = `/${env}/${api}/${app}/`
    }

    client.defaults.headers.common['Accept-Language'] = userLanguage ? userLanguage : 'en';
    client.defaults.baseURL = API

    const onSuccess = function (response) {
        if (response.headers.jsessionid) {
            client.defaults.headers.post['JSESSIONID'] = response.headers.jsessionid;
        }

        return response.data;
    };

    const onError = function (error) {
        if (error.response && error.response.status === 304 && error.response.headers.location) {
            const nextUrl = window.location.pathname.split('/').slice(2).join('/')
            sessionStorage.setItem("comeFrom", nextUrl)
        }
        if (error.response) {
            //redirect
            if (error.response.status === 304 && error.response.headers.location) {
                if (window.location.href === error.response.headers.location) return;
                window.location = error.response.headers.location
                return
            }
            // if (error.response.status === 307) {
            //     history.push({
            //         pathname: '/changePassword',
            //         state: {isFromLogin: true}
            //     });
            // }
            if (error.response.status === 401) {
                console.log('auth failed');
                //history.push('/login');
            }

        } else {
            // Something else happened while setting up the request
            // triggered the error
            console.error('Error Message:', error.message);
        }

        return Promise.reject(error.response || error.message);
    };


    return client(options)
        .then(onSuccess)
        .catch(onError);
};
export default request;
